import { render, staticRenderFns } from "./classTec.vue?vue&type=template&id=837f90b8&scoped=true&"
import script from "./classTec.vue?vue&type=script&lang=js&"
export * from "./classTec.vue?vue&type=script&lang=js&"
import style0 from "./classTec.vue?vue&type=style&index=0&id=837f90b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f90b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
